module.exports = __webpack_public_path__ + "static/img/04_tone_cloud.5a5a104.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/04_tone_cloud.jpg
// module id = nKDe
// module chunks = 13